var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollContainer",staticClass:"scroll-manager",class:{
    'scroll-manager--scrolling': _vm.scrolling,
    'scroll-manager--enabled': _vm.scrollEnabled,
  }},[_c('svg',{staticClass:"scroll-manager__placeholder",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"1920","height":"1080"}},[_c('rect',{staticStyle:{"fill":"transparent"},attrs:{"x":"2","y":"2","width":"1916","height":"1076"}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }